import React from 'react';
import styles from './PlanTermsStep.module.css';

const FEATURES = [
  { title: 'Unlimited VIN Lookups', description: 'Decode VINs and pull instant market context for any vehicle.' },
  { title: 'AI Market Dashboard', description: 'Top selling makes/models, demand signals, and what\'s moving in your market.' },
  { title: 'Active + Sold Comps & Pricing Trends', description: 'See price vs market, ranges, and how pricing is shifting.' },
  { title: 'Dealer Insights: Market Ranking & Performance', description: 'Track your lot vs the market (sell-through, turn, movers).' },
  { title: 'Recommended Private Acquisitions (FB Marketplace)', description: 'Underpriced private-party leads surfaced automatically in your radius.' },
  { title: 'AI Buy / Hold / Avoid Insights', description: 'Fast, dealer-friendly recommendations based on comps + liquidity signals.' },
];

function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={styles.featureTileCheck}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

const IncludedFeaturesGrid = () => (
  <div className={styles.includedSection}>
    <h4 className={styles.includedTitle}>What's Included</h4>
    <div className={styles.featureGrid}>
      {FEATURES.map((item, index) => (
        <div key={index} className={styles.featureTile}>
          <CheckIcon />
          <div className={styles.featureTileContent}>
            <span className={styles.featureTileTitle}>{item.title}</span>
            <span className={styles.featureTileDesc}>{item.description}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default IncludedFeaturesGrid;
